import { Article } from '@mui/icons-material';
import { Link, IconButton, List, ListItem, ListItemButton, Popover, Tooltip } from '@mui/material';
import { action, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';

interface IRelatorioAndTramTrans {

}


class RelatorioAndTramTrans extends React.Component {
    open = false;
    anchorEl;

    handleOpen = (e: React.MouseEvent) => {
        this.anchorEl = e.currentTarget;
        e.stopPropagation();
        this.open = true;
    };

    handleClose = (e: React.MouseEvent) => {
        this.anchorEl = null;
        e.stopPropagation();
        this.open = false;
    };

    constructor(props: IRelatorioAndTramTrans) {
        super(props);

        makeObservable(this, {
            open: observable,
            anchorEl: observable,
            handleOpen: action,
            handleClose: action
        });
    }

    render() {
        return (
            <div>
                <Tooltip title='Relatório de andamentos, tramitações e transições'>
                    <div>
                        <IconButton size='large' onClick={this.handleOpen} style={{ color: 'rgb(1, 87, 155)' }} aria-label='Menu de Relatório de andamentos, tramitações e transições.'>
                            <Article sx={{ color: 'white' }} />
                        </IconButton>
                    </div>
                </Tooltip>
                <Popover open={this.open}
                    onClose={this.handleClose}
                    anchorEl={this.anchorEl}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                    slotProps={{
                        paper: {
                            sx: {
                                ml: 2
                            }
                        }
                    }}
                >   
                    <List sx={{ bgcolor: 'background.paper' }}>
                        <ListItem key={'BOmovInterna'} style={{ cursor: 'pointer', borderRadius: '5px' }}>
                            <ListItemButton>
                                <Link href="http://sad.redejt/BOE/OpenDocument/opendoc/openDocument.jsp?sIDType=CUID&iDocID=FqGxD2OO5A0AdNQAAAAHpNZ7AFBWgpok" underline="none" color="inherit" target="_blank">
                                    <span style={{ marginRight: '8px' }}>Histórico de Movimentação Interna</span></Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'PowerBI'} style={{ cursor: 'pointer', borderRadius: '5px' }}>
                            <ListItemButton>
                                <Link
                                    href="https://app.powerbi.com/Redirect?action=OpenApp&appId=ab6aab7f-b893-4090-a372-55a6f0e1f68c&ctid=ccd9917e-cb47-42a5-a262-e2272dcef6ab&experience=power-bi"
                                    target="_blank"
                                    underline="none"
                                    color="inherit"
                                >
                                <span style={{ marginRight: '8px' }}>Relatório de Enviados/Recebidos</span>
                                </Link>
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Popover>
            </div>
        );
    }
}

export default observer(RelatorioAndTramTrans);
